import { Navigate } from "react-router-dom";

import { useApp } from "@/context/AppContext";
import { growthEnabled } from "@/growth/pilot";
import { PageError, PageLoading } from "@/components/LiveState";

/** The Test section exists only for pilot workspaces; everyone else lands back on Your Agent. */
export function GrowthGate({ children }) {
  const { activeClient } = useApp();
  if (!growthEnabled(activeClient?.clientSlug)) return <Navigate to="/" replace />;
  return children;
}

/** Loading and error states shared by the growth pages: the first load waits, later errors keep the last good data. */
export function GrowthPageState({ resource, label, title, children }) {
  if (!resource.data && resource.status === "loading") return <PageLoading label={label} />;
  if (!resource.data && resource.status === "error") return <PageError error={resource.error} onRetry={resource.reload} title={title} />;
  return <>
    {resource.data && (resource.stale || resource.error) ? (
      <div role="status" className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="growth-stale-warning">
        <span>Refresh failed. Showing the last successful response; these values may be out of date.</span>
        <button type="button" className="btn-outline" disabled={resource.status === "loading"} onClick={() => resource.reload().catch(() => undefined)}>
          {resource.status === "loading" ? "Retrying…" : "Retry"}
        </button>
      </div>
    ) : null}
    {children}
  </>;
}
